import { isReactNative } from 'yofobasement/utils/runtime';

export default {
  create: (data) => {
    if (isReactNative()) {
      return require('react-native').PanResponder.create(data);
    } else {
      return { panHandlers: {} };
    }
  }
};



// WEBPACK FOOTER //
// ../biz-micro-services-ui/packages/basement/utils/PanResponder.js